import React, { useState, useEffect } from 'react';
import './GiftModal.css';
import Fireworks from './Fireworks';

const GiftModal = ({ isOpen, onClose, giftContent }) => {
  const [showFireworks, setShowFireworks] = useState(false);
  
  // Show fireworks when modal opens
  useEffect(() => {
    if (isOpen) {
      setShowFireworks(true);
      
      // Remove fireworks after 5 seconds to avoid overwhelming the screen
      const timer = setTimeout(() => {
        setShowFireworks(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  // Handler for clicking on the overlay (outside the modal content)
  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not its children
    if (e.target.className === 'modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      {showFireworks && <Fireworks />}
      <div className="modal-content">
        <button className="modal-close-button" onClick={onClose}>×</button>
        <div className="gift-reveal">
          <h4>{giftContent}</h4>
        </div>
        {giftContent === 'Challe' && (
          <div className="poem-content">
            <p className="poem-title">"My Princess"</p>
            <p>
            You keep me alive in the most unlivable fights.<br/>
            Your blue beam is more than a boost, it’s confidence.<br/>
            You may have no kills, no fame, no POTG.<br/>
            Yet somehow, you're always the one pure and true.<br/>
            You will always be my MVP.<br/>
            Honest, how do you do it?<br/><br/>
              Happy Birthday to you!<br/>
            </p>
          </div>
        )}
        {giftContent === 'Steam Gift Card' && (
          <div className="gift-card-content">
            <div className="gift-card-details">
              <p>Redeem Code: <strong>B82CM-E67N0-2MKEB</strong></p>
            </div>
            <p className="gift-card-note">Redeem on the Steam Store <span className="steam-icon">🎮</span></p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftModal;
